import React from 'react';

const Performance = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Performance Reviews</h2>
      <div className="text-gray-500 text-center py-12 bg-white shadow-sm border border-gray-200 rounded-xl">
        You do not have any performance reviews yet.
      </div>
    </div>
  );
};

export default Performance;
